export const hasOnlySpaces = (query: string): boolean =>
  query.trim().length === 0;
